import ReplyIcon from "@mui/icons-material/Reply";
import { type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

interface ReplyIconButtonProps {
  onClick: () => void;
  isIncoming: boolean;
  sx?: SxProps<Theme>;
}

export function ReplyIconButton(props: ReplyIconButtonProps) {
  const { isIncoming } = props;

  return (
    <ReplyIcon
      aria-label="Reply to message"
      tabIndex={0}
      // eslint-disable-next-line jsx-a11y/prefer-tag-over-role
      role="button"
      sx={mergeSxProps(
        (theme) => ({
          fontSize: "16px",
          color: isIncoming
            ? theme.palette.text.secondary
            : (theme.palette.base?.inverted?.muted ?? "rgba(255, 255, 255, 0.7)"),
          cursor: "pointer",
          flexShrink: 0,
          alignSelf: "center",
          marginBottom: "2px",
          "&:hover": {
            color: isIncoming
              ? theme.palette.text.primary
              : (theme.palette.base?.inverted?.strong ?? "rgba(255, 255, 255, 1)"),
          },
        }),
        props.sx
      )}
      onClick={props.onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          props.onClick();
        }
      }}
    />
  );
}
